/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var FacebookFIcon = createIcon({
  name: 'FacebookFIcon',
  height: 512,
  width: 264,
  svgPath: 'M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default FacebookFIcon;